import React from "react";
import { useLocation } from "react-router-dom";
import CategoryCard from "./CategoryCard";
import cardData from "../data/cardData.json";

const FavorTags = () => {
  const location = useLocation();
  const { filterCategory } = location.state || {};

    // If filterCategory is provided, filter based on it; otherwise, default to "Favor Tags"
    const birthdayCards = cardData.filter(card =>
      card.category === (filterCategory || "Favor Tags")
    );

  return (
    <div className="container mt-4">
      {/* <h2>Favor Tags</h2> */}
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {birthdayCards.map((card) => (
          <CategoryCard key={card.id} card={card} />
        ))}
      </div>
    </div>
  );
};

export default FavorTags;
